<template>
    <div class="sub-page">
        <div class="btn-close"><Icon type="ios-close-circle-outline" @click="cancel" /></div>
        <div class="sub-page-bd">
            <Form ref="form" :model="formData" :label-width="120">
                <FormItem :label="$t('mod_cname')" prop="role_cname">
                    <Input v-model="formData.mod_cname" disabled></Input>
                </FormItem>
                <FormItem :label="$t('role_cname')" prop="role_cname">
                    <Input v-model="role_cname" disabled></Input>
                </FormItem>
                <FormItem :label="$t('select_func')">
                    <Tree class="tree-edit" ref="tree" :data="listData" show-checkbox multiple></Tree>
                </FormItem>
            </Form>
        </div>
        <div class="sub-page-ft">
            <Button style="margin-right: 8px" @click="cancel">{{$t('cancel')}}</Button>
            <Button type="primary" @click="submit">{{$t('save')}}</Button>
        </div>
    </div>
</template>

<script>
    export default {
        data:function(){
            return{
                formData: {
                    role_id:'',
                    mod_cname:'',
                    funcs :[],
                    mod_id: '',
                },
                role_cname: '',
                listData: [],
                item: {}
            }
        },
        mounted: function(){
            this.$parent.$parent.show_subview = true;
            this.item = JSON.parse(this.$base.getRequest().data);
            this.formData.role_id = this.item.role_id;
            this.formData.mod_id = this.item.mod_id;
            this.formData.mod_cname = this.item.mod_cname;
            this.role_cname = this.item.role_cname;
            this.getInfo();
        },
        methods:{
            cancel: function(){
                this.$base.linkBack();
            },
            getInfo: function(){
                const data = {
                    role_id: this.item.role_id,
                    mod_id: this.item.mod_id
                }
                this.$base.showLoading();
                this.$request.sendPost("mod/before-upd-role-func", data,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.funcs;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            submit: function(){
                this.formData.funcs = [];
                var check_data = this.$refs["tree"].getCheckedNodes();
                check_data.map(item => {
                    if(item.func_type && item.func_type == 'P'){
                        this.formData.funcs.push(item.func_id)
                    }
                });
                this.$refs["form"].validate((valid) => {
                    if (valid) {
                        var url = "mod/upd-role-func";
                        this.$base.showLoading();
                        this.$request.sendPost(url,this.formData,(success,data,error)=>{
                            this.$base.hideLoading();
                            if(success){
                                this.$base.alertSuccess(error.errmsg);
                                this.relist = true;
                                this.$base.linkBack();
                            }
                            else{
                                this.$base.alertErr(error.errmsg);
                            }
                        });
                    } else {
                        this.$base.alertErr(this.$t('incomplete'));
                    }
                })
            }
        },
        beforeDestroy: function () {
            this.$parent.$parent.show_subview = false;
            this.$parent.$parent.relist = this.relist;
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/mod_role_func.vue